<template>
  <div class="page">
    <YorkbbsHeader class="page-header" width="1170px"></YorkbbsHeader>
    <YorkbbsTopic></YorkbbsTopic>
    <section class="page-wrapper">
      <YorkbbsBrandCollapse @change="onBrandChange"></YorkbbsBrandCollapse>
      <YorkbbsFilter
        class="page-filter"
        :brand="brand"
        :total="itemTotal"
        :sortType.sync="sortType"
        @sortChange="onSortChange"
        @filterChange="onFilterChange"
      ></YorkbbsFilter>

      <YorkbbsSkeleton class="car-skeleton" :count="20" animated :loading="loading">
        <div slot="template" class="car-skeleton__item">
          <el-skeleton-item variant="image"></el-skeleton-item>
          <el-skeleton-item class="p1" variant="p"></el-skeleton-item>
          <el-skeleton-item class="p2" variant="p"></el-skeleton-item>
          <el-skeleton-item class="p3" variant="p"></el-skeleton-item>
        </div>
      </YorkbbsSkeleton>

      <div class="car-list" v-show="!loading">
        <template v-for="(post, i) in posts">
          <YorkbbsInfoflowItem :key="i" :data="post" v-if="post.app === 'crm_ad'"></YorkbbsInfoflowItem>
          <YorkbbsCarItem class="car-item" :key="i" :data="post" :topVisible="sortType === 1" v-else></YorkbbsCarItem>
        </template>
      </div>

      <YorkbbsPagination
        v-if="itemTotal"
        :current-page.sync="offset"
        :page-size.sync="size"
        :total="itemTotal"
        @current-change="onPostPageChange"
      ></YorkbbsPagination>

      <YorkbbsEmptyResult v-if="!loading && !posts.length" text="没有符合条件的车源，看看其他的吧"></YorkbbsEmptyResult>
    </section>
    <YorkbbsFooter class="page-footer" v-if="!loading"></YorkbbsFooter>

    <!-- 返回顶部 -->
    <YorkbbsBackup
      :publishVisible="true"
      :publishTitle="'卖车'"
      :publishURL="'/publish/lease'"
      :homeVisible="true"
      :homeURL="'/center/information?type=4' | hostBuild('home')"
      :opinionVisible="true"
    ></YorkbbsBackup>
  </div>
</template>
<script>
import { inflowAdvConvert } from '@/utils/utils';
import { topicMapping } from '../components/data';
import YorkbbsHeader from '@/common/header/header.vue';
import YorkbbsFooter from '@/common/footer/footer.vue';
import YorkbbsTopic from '../components/topic.vue';
import YorkbbsBrandCollapse from '../components/collapse-brand.vue';
import YorkbbsFilter from './filter-sort.vue';
import YorkbbsCarItem from '../components/item-lease.vue';
import YorkbbsPagination from '../components/pagination.vue';
import YorkbbsEmptyResult from '@/common/empty-result/empty-result.vue';
import YorkbbsBackup from '@/common/tools-backup.vue';
import YorkbbsInfoflowItem from '../components/item-infoflow.vue';
import YorkbbsSkeleton from '@/common/skeleton.vue';
export default {
  name: 'ListLease',
  components: {
    YorkbbsHeader,
    YorkbbsFooter,
    YorkbbsTopic,
    YorkbbsBrandCollapse,
    YorkbbsFilter,
    YorkbbsCarItem,
    YorkbbsPagination,
    YorkbbsEmptyResult,
    YorkbbsBackup,
    YorkbbsInfoflowItem,
    YorkbbsSkeleton,
  },
  data() {
    return {
      // 排序类型 1 推荐 2 最新 3 价格↑ 4 价格↓
      sortType: 1,
      // 当前页码
      offset: 1,
      // 每页显示的记录数
      size: 20,
      // 加载状态
      loading: false,
      // 汽车列表
      posts: [],
      // 总记录数
      itemTotal: 0,
      // 筛选条件查询语句
      filterQuery: undefined,
      // 汽车品牌
      brand: { nameCN: '全部', name: '' },
    };
  },
  computed: {
    // 当前版块
    topic() {
      return topicMapping[this.$route.path.split('/')[2]];
    },
  },
  created() {
    this.getPosts();
  },
  methods: {
    /**
     * 获取二手车列表
     */
    async getPosts() {
      let url,
        params = { offset: this.offset, size: this.size, brandEnName: this.$route.params.brand };
      if (this.sortType === 1) {
        url = '/car/v1/get/mainpage/hot/post';
        params = {
          ...params,
          topicId: this.topic.id,
          options: { ...this.filterQuery },
        };
      } else if (this.sortType === 2) {
        url = '/car/v1/get/post/list';
        params = {
          ...params,
          options: { sort: ['createdAt:DESC'], ...this.filterQuery },
          topicIds: [this.topic.id],
        };
      } else if (this.sortType === 3) {
        url = '/car/v1/get/post/list';
        params = {
          ...params,
          options: { sort: ['property_monthlySupply:ASC'], ...this.filterQuery },
          topicIds: [this.topic.id],
        };
      } else if (this.sortType === 4) {
        url = '/car/v1/get/post/list';
        params = {
          ...params,
          options: { sort: ['property_monthlySupply:DESC'], ...this.filterQuery },
          topicIds: [this.topic.id],
        };
      }

      this.loading = true;
      const { data } = await this.$axios.post(url, params).finally(() => {
        this.loading = false;
      });

      // 处理信息流广告轮显
      data.items = inflowAdvConvert(data.items, 'car', '30000');

      this.posts = data.items;
      this.itemTotal = data.itemTotal;
    },
    /**
     * 重置列表数据
     */
    resetPost() {
      this.offset = 1;
      this.loading = false;
    },
    /**
     * 排序发生变化
     */
    onSortChange() {
      this.resetPost();
      this.getPosts();
    },
    /**
     * 翻页
     */
    async onPostPageChange(page) {
      this.offset = page;
      document.documentElement.scrollTop = 0;
      await this.getPosts();
    },
    /**
     * 筛选条件发生变化
     */
    onFilterChange(query) {
      this.filterQuery = { ...(this.filterQuery || {}), ...query };
      this.resetPost();
      this.getPosts();
    },
    /**
     * 品牌发生变化
     */
    onBrandChange(brand) {
      this.brand = brand || this.$options.data().brand;
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
  min-height: 100vh;
}
.page-header {
  margin-bottom: 15px;
}
.page-footer {
  margin-top: 100px;
}
.page-wrapper {
  width: 1170px;
  margin: auto;
}
.car-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
  margin-left: -10px;
  margin-right: -10px;
}

.car-item,
.infoflow-item {
  &:not(:nth-child(4n)) {
    margin-right: 23.333333333px;
  }
}

.car-skeleton {
  margin-left: -10px;
  margin-right: -10px;
  .car-skeleton__item {
    width: 280px;
    padding: 10px;
    height: 327px;
    box-sizing: border-box;
  }
  ::v-deep {
    .el-skeleton {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-top: 20px;
      text-align: center;
    }
    .el-skeleton__image {
      width: 258px;
      height: 195px;
      margin: auto;
    }
    .el-skeleton__p {
      display: block;
      margin-top: 13px;
    }
    .p1 {
      width: 80%;
    }
    .p2 {
      width: 40%;
    }
    .p3 {
      width: 60%;
    }
  }
}
</style>
